import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F8824Service {

  constructor(private http: HttpClient) { }

  /**
   * Fetch Form 8824 Master Data
   * Action code: 'godt2p'
   */
  fetchF8824MasterData(
    rowData: any,
    sso_id: string,
    baseUrl: string,
    globalService?: any,
    filterParams?: any
  ): Observable<any> {
    let jcd_key = 0;
    if (rowData.JCD_KEY == undefined) {
      jcd_key = 250;
    } else {
      jcd_key = rowData.JCD_KEY;
    }
    
    const params: any = {
      action_code: 'godt2p',
      sso_id: sso_id,
      tax_year: rowData.TAX_YEAR,
      scenario: rowData.SCENARIO,
      jcd_key: jcd_key,
      combination_key: rowData.COMBINATION_KEY,
      jcd_ta_key: null
    };
    
    // Merge with globalService.globalParams and filterParams (like AngularJS does)
    // Note: globalService is the entire header object, globalParams contains the actual params
    let mergedParams = _.merge({}, globalService?.globalParams || {}, filterParams || {}, params);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(mergedParams).forEach(key => {
      if (mergedParams[key] !== null && mergedParams[key] !== undefined) {
        urlEncoded.set(key, mergedParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  /**
   * Fetch Form 8824 Transaction Details
   * Action code: '3l9jav'
   */
  fetchF8824Details(
    rowData: any,
    sso_id: string,
    baseUrl: string,
    globalService?: any,
    filterParams?: any
  ): Observable<any> {
    let jcd_key = 0;
    if (rowData.JCD_KEY == undefined) {
      jcd_key = 250;
    } else {
      jcd_key = rowData.JCD_KEY;
    }
    
    const params: any = {
      action_code: '3l9jav',
      sso_id: sso_id,
      tax_year: rowData.TAX_YEAR,
      scenario: rowData.SCENARIO,
      jcd_key: jcd_key,
      combination_key: rowData.COMBINATION_KEY,
      jcd_ta_key: null
    };
    
    // Merge with globalService.globalParams and filterParams
    // Note: globalService is the entire header object, globalParams contains the actual params
    let mergedParams = _.merge({}, globalService?.globalParams || {}, filterParams || {}, params);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(mergedParams).forEach(key => {
      if (mergedParams[key] !== null && mergedParams[key] !== undefined) {
        urlEncoded.set(key, mergedParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  /**
   * Fetch List of Values (LOV)
   * Action code: 'sjh60s'
   */
  fetchLOV(
    baseUrl: string,
    params: any
  ): Observable<any> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  /**
   * Fetch Modal Calculation Data
   * Action code: '1ubsuu'
   */
  fetchModalCalcData(
    baseUrl: string,
    params: any
  ): Observable<any> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  /**
   * Save Form 8824 Data
   * Action code: '6gt0ia'
   * Process name: 'form-8824-save'
   */
  saveForm8824(
    baseUrl: string,
    final_data: any[],
    clob_settings: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build payload EXACTLY like original AngularJS
    // AngularJS: params = _.merge({}, GlobalService.globalParams, params);
    // Note: globalService is the entire header object, globalParams contains the actual params
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);

    // Essential parameters with fallbacks
    params.json_data = JSON.stringify(final_data);
    params.json_settings = JSON.stringify(clob_settings);
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.process_name = "form-8824-save";

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=6gt0ia`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }
}

